<div
  *ngIf="isVisible"
  role="status"
  data-testid="launch-confirmation-banner"
  class="flex flex-wrap items-center mt-2 gap-x-3 gap-y-1.5 w-full min-w-0 px-3 py-1.5 bg-amber-50 border border-amber-300 rounded-md"
>
  <div class="flex items-center gap-2 flex-1 min-w-0">
    <svg
      class="shrink-0 w-[14px] h-[14px] 2xl:w-[16px] 2xl:h-[16px] text-amber-600"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="9.5"
        stroke="currentColor"
        stroke-width="1.8"
      />
      <path
        d="M12 11v5.5"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <circle cx="12" cy="7.75" r="1.1" fill="currentColor" />
    </svg>
    <span
      class="text-dimot-1 text-[0.6rem] xl:text-[0.7rem] 2xl:text-[0.8rem] break-words"
    >
      Il prodotto ha raggiunto il
      <span class="font-[MontserratBold]"
        >{{ displayedLaunchPercentage }}% di Apertura Ospedaliera/Accesso</span
      >. Vuoi confermare che il prodotto è sul mercato?
    </span>
  </div>
  <div class="flex items-center gap-2 shrink-0 ml-auto">
    <button
      type="button"
      data-testid="launch-confirm-button"
      class="h-[24px] 2xl:h-[28px] px-3 rounded-md bg-[#008236] hover:bg-[#01a043] text-white text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.65rem] cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-[#008236]"
      [disabled]="isConfirming"
      (click)="confirmLaunch()"
    >
      Conferma lancio
    </button>
    <button
      type="button"
      data-testid="launch-dismiss-button"
      class="h-[24px] 2xl:h-[28px] px-3 rounded-md border border-dimot-1 bg-white hover:bg-dimot-1 text-dimot-1 hover:text-white text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.65rem] cursor-pointer"
      (click)="dismiss()"
    >
      Più tardi
    </button>
  </div>
</div>
